export enum BehaviorCodeInterventionsTableColumns {
  NAME = 'Name',
  DESCRIPTION = 'Description',
  TRIGGER_AT = 'Assigned At',
  ACTIONS = 'Actions'
}
